<template>
	<div>
		<h1
			class="title d-sm-none text-center"
			:class="ativo == true ? null : 'red--text'"
		>
			{{ $route.meta.breadCrumb }}
		</h1>

		<v-card class="mb-1">
			<!-- Toolbar -->
			<v-toolbar dense flat dark color="blue-grey darken-3">
				<v-toolbar-title
					class="d-none d-sm-block"
					:class="ativo == true ? null : 'red--text'"
					>{{ $route.meta.breadCrumb }}</v-toolbar-title
				>
				<v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>

				<v-text-field
					v-model="dataTable.search"
					append-icon="mdi-magnify"
					label="Filtrar"
					single-line
					hide-details
				></v-text-field>
			</v-toolbar>

			<!-- Toolbar -->
			<v-toolbar dense flat dark color="blue-grey darken-4">
				<v-spacer></v-spacer>
				<v-toolbar-title class="d-none d-sm-block">Ações</v-toolbar-title>
				<v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>

				<v-btn :to="{ name: 'CursosList' }" title="Valtar" icon color="white">
					<v-icon>fal fa-arrow-left</v-icon>
				</v-btn>

				<v-btn
					@click="dialog = !dialog"
					title="Cadastrar"
					icon
					color="blue darken-2"
				>
					<v-icon>fal fa-plus</v-icon>
				</v-btn>

				<v-btn
					title="Recarregar dados"
					icon
					@click="initialize()"
					color="orange lighten-1"
				>
					<v-icon>fal fa-repeat</v-icon>
				</v-btn>

				<v-btn
					:title="ativo ? 'Mudar para intivos' : 'Mudar para ativos'"
					icon
					@click="ativo = !ativo"
					:color="ativo == true ? 'green' : 'red'"
				>
					<v-icon>fal fa-archive</v-icon>
				</v-btn>

				<ArrayToExcel v-if="dados.length > 0" :dados="dados" :excel="excel" />
			</v-toolbar>
		</v-card>

		<!-- DataTable -->
		<DataTable :dados="dados" :dataTable="dataTable">
			<template v-slot:actions="{ item }">
				<v-icon small class="mr-3" title="Editar" @click="editItem(item)"
					>far fa-pencil</v-icon
				>
				<v-icon small class="mr-3" title="Mostrar" @click="showDialog(item)"
					>far fa-eye</v-icon
				>
				<v-icon
					small
					:title="ativo ? 'Desativar' : 'Ativar'"
					@click="deleteItem(item)"
					>far fa-archive</v-icon
				>
			</template>
		</DataTable>

		<v-dialog v-model="dialogShow" max-width="550px">
			<v-card tile>
				<v-card-title
					>{{ dialogShowHeader }}<v-spacer></v-spacer>
					<v-btn color="primary" @click="dialogShow = !dialogShow" icon
						><v-icon>fal fa-times</v-icon></v-btn
					>
				</v-card-title>
				<v-list shaped>
					<v-list-item-group color="primary">
						<v-list-item v-for="(data, key) in dialogShowData" :key="key">
							<v-list-item-content>
								<v-list-item-title>{{ key }}</v-list-item-title>
								<v-list-item-subtitle v-if="key == 'ativo'">{{
									data == 1 ? 'Sim' : 'Não'
								}}</v-list-item-subtitle>
								<v-list-item-subtitle v-else>{{ data }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-card>
		</v-dialog>

		<!-- Dialog -->
		<v-dialog v-model="dialog" max-width="500px">
			<v-card>
				<v-card-title>
					<span class="headline">{{ formTitle }}</span>
				</v-card-title>

				<v-card-text>
					<v-form ref="form">
						<v-container>
							<v-row>
								<v-col cols="12" sm="6">
									<MonthPicker v-if="dialog" :date="editedItem.inicio" label="Início" @newVal="editedItem.inicio=$event"></MonthPicker>
								</v-col>
								<v-col cols="12" sm="6">
									<MonthPicker v-if="dialog" :date="editedItem.fim" label="Fim" @newVal="editedItem.fim=$event"></MonthPicker>
								</v-col>
								<v-col cols="12">
									<v-textarea
										v-model="editedItem.obs"
										label="Observação"
										rows="2"
									></v-textarea>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" dark @click="close"
						><v-icon left>fal fa-times</v-icon> Fechar</v-btn
					>
					<v-btn color="blue darken-1" dark @click="save"
						><v-icon left>fas fa-save</v-icon> Salvar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<br style="clear:left;" />
	</div>
</template>

<script>
import { mapState } from 'vuex'

import ArrayToExcel from '@/components/ArrayToExcel'
import DataTable from '@/components/DataTable'
import MonthPicker from '@/components/MonthPicker'

export default {
	components: {
		ArrayToExcel,
		DataTable,
    MonthPicker
	},
	data() {
		return {
			server: 'periodos',
			contatoEmail: true,
			contatoTelefone: false,
			ativo: true,
			dialog: false,
			dialogShow: false,
			dialogShowData: false,
			dialogShowHeader: 'Dados',
			dados: [],
			dataTable: {
				headers: [
					{ text: 'ID', value: 'id' },
					{ text: 'Curso', value: 'curso', align: 'start' },
					{ text: 'Início', value: 'inicio', align: 'start' },
					{ text: 'Fim', value: 'fim' },
					{ text: 'Ações', value: 'actions', sortable: false },
				],
				sortBy: 'nome',
				sortDesc: false,
				multiSort: false,
				search: '',
				loading: true,
			},
			excel: {
				name: undefined,
				fields: {
					Id: 'id',
					Curso: 'curso',
					Início: 'inicio',
					Fim: 'fim',
					Obs: 'obs',
					'Data cad': 'datacad',
				},
			},
			editedIndex: -1,
			editedItem: {},
			defaultItem: {
				id: '',
				curso_id: '',
				inicio: null,
				fim: null,
				obs: '',
			},
		}
	},
	computed: {
		...mapState(['user', 'rules']),
		formTitle() {
			return this.editedIndex === -1 ? 'Cadastrar' : 'Editar'
		},
	},

	watch: {
		dialog(val) {
			val || this.close()
		},
		ativo() {
			this.initialize()
		},
	},
	created() {
		this.defaultItem.curso_id = this.$route.params.id
		this.editedItem = Object.assign({}, this.defaultItem)
		this.initialize()
	},

	methods: {
		excelName() {
			this.excel.name = this.$route.meta.breadCrumb + '-' + Date() + '.xls'
		},
		showDialog(item) {
			this.dialogShowData = Object.assign({}, item)
			this.dialogShow = true
		},
		initialize() {
			this.excelName()
			this.dataTable.loading = true
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_' + this.server)
			formData.append('ativo', this.ativo)
			formData.append('curso_id', this.$route.params.id)
			let vd = this

			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						if (response.data.dados != undefined) {
							vd.dados = response.data.dados
						} else {
							vd.dados = []
						}
						setTimeout(function() {
							vd.dataTable.loading = false
						}, 1000)
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},

		editItem(item) {
			this.editedIndex = this.dados.indexOf(item)
			this.editedItem = Object.assign({}, item)
			this.contatoEmail = this.editedItem.email == 1 ? true : false
			this.contatoTelefone = this.editedItem.telefone == 1 ? true : false
			this.dialog = true
		},

		deleteItem(item) {
			this.excelName()
			const index = this.dados.indexOf(item)
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'delete_' + this.server)
			formData.append('ativo', !this.ativo)
			formData.append('id', item.id)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.dados.splice(index, 1)
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},

		close() {
			this.dialog = false
			setTimeout(() => {
				this.editedItem = Object.assign({}, this.defaultItem)
				this.editedIndex = -1
				this.$refs.form.resetValidation()
			}, 300)
		},

		save() {
			if (this.$refs.form.validate()) {
				if (this.editedIndex > -1) {
					this.excelName()

					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_' + this.server)
					Object.entries(this.editedItem).forEach(([key, value]) => {
						formData.append(key, value)
					})
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.initialize()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destino: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERRO!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_' + this.server)
					Object.entries(this.editedItem).forEach(([key, value]) => {
						formData.append(key, value)
					})
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.editedItem.id = response.data.id
								vd.initialize()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destino: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERRO!! ' + response)
						})
				}
			}
		},
	},
}
</script>
